export default {
  // Words
  account: 'حساب کاربری',
  add: 'افزودن',
  audit: 'تایید نهایی',
  dashboard: 'پروفایل',
  home: '@:branding.appTagline',
  profile: 'اطلاعات شخصی',
  transports: 'درخواست های حمل'
}
